import { render, staticRenderFns } from "./papertemplateDialog.vue?vue&type=template&id=008fc50e&scoped=true&"
import script from "./papertemplateDialog.vue?vue&type=script&lang=js&"
export * from "./papertemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./papertemplateDialog.vue?vue&type=style&index=0&id=008fc50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008fc50e",
  null
  
)

export default component.exports